App = App || {};

App.DealerDetail = (function ($, Vue) {
    "use strict";

    var $modal;

    function init(rootElement) {
        rootElement = rootElement || document.getElementById("dealer-detail-app");
        if (!rootElement || rootElement.dataset.mounted)
            return;

        rootElement.dataset.mounted = "1";

        $modal = $(rootElement).closest(".modal");

        new Vue({
            el: rootElement,
            data: {
                dealer: {
                    id: $modal.data("id") || "",
                    bpCode: '',
                    cardName: ''
                },
                countries: [],
                dealers: [],
                reps: [],
                isLoading: false,
                isSaving: false,
                isComplete: false,
                alertMessage: "",
                alertErrors: []
            },

            computed: {
                currentCountry: function () {
                    return this.countries.find(c => c.code === this.dealer.country);
                },
                currentRegions: function () {
                    return this.currentCountry?.regions || [];
                },
                storeAddress: function () {
                    return [this.dealer?.street, this.dealer?.city, this.dealer?.region]
                        .filter(Boolean)
                        .join(", ");
                }
            },

            methods: {
                formatDate: function (value) {
                    if (!value)
                        return "";
                    var normalized = String(value).replace(/(\.\d{3})\d+$/, "$1");
                    var d = new Date(normalized);
                    return isNaN(d) ? String(value) : d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
                },

                onCountryChange: function () {
                    const selectedCountry = this.countries.find(c => c.code === this.dealer.country);
                    this.dealer.region = (selectedCountry?.regions?.[0]?.code) || "";
                },

                formatDealerLabel: function (dealer) {
                    if (!dealer)
                        return "";

                    return `${dealer.name} (${dealer.city}, ${dealer.state})`;
                },

                loadCountries: function () {
                    $.ajax({
                        url: "/api/countries",
                        method: "GET",
                        dataType: "json"
                    })
                    .done(response => {
                        if (response.success) {
                            this.countries = response.data;
                            if (!this.dealer.region)
                                this.onCountryChange();
                        }
                    })
                    .fail((jqXHR, status, err) => {
                        console.error("AJAX error loading countries:", status, err);
                    });
                },

                loadReps: function () {
                    $.ajax({
                        url: "/api/members/byrole?role=CS Rep",
                        method: "GET",
                        dataType: "json"
                    }).done(response => {
                        if (response.success) {
                            this.reps = response.data;

                            const id = this.dealer.csRep?.id ?? null;
                            this.dealer.csRep = this.reps.find(d => d.id === id) || null;
                        }
                    }).fail((jqXHR, status, err) => {
                        console.error("AJAX error loading reps:", status, err);
                    });
                },

                onRowClick: function (item, index, evt) {
                    if (!item || !item.id)
                        return;

                    $modal.data("id", item.id);
                    this.loadDealer();
                },

                openAdjust: function (memberId) {
                    $modal.off('hidden.bs.modal').one('hidden.bs.modal', function () {
                        App.BalanceAdjustOffcanvas.open(memberId, () => $modal.modal("show"))
                    });

                    $modal.modal('hide');
                },

                close: function () {
                    $modal.modal("hide");
                },

                loadDealer: function (id) {
                    id = id || $modal.data("id");

                    return $.ajax({
                        url: `/api/dealers/${id}`,
                        method: "GET",
                        dataType: "json"
                    })
                    .done(response => {
                        if (!response || !response.success || !response.data) {
                            this.alertMessage = (response && response.message) || "Failed loading profile.";
                            return;
                        }

                        this.dealer = response.data;
                    })
                    .fail((jqXHR, status, err) => {
                        console.error("AJAX error loading profile:", status, err);
                        this.alertMessage = "Failed loading profile.";
                    });
                },

                scrollToFormTop() {
                    this.$nextTick(() => {
                        const topOffset = this.$el.getBoundingClientRect().top + window.pageYOffset - 20;
                        window.scrollTo({ top: topOffset, behavior: 'smooth' });
                        this.$refs.topAlert?.focus?.({ preventScroll: true });
                    });
                },

                reset: function () {
                    this.isSubmitting = false;
                    this.isComplete = false;
                    this.alertMessage = "";
                    this.alertErrors = [];
                },

                save: function () {
                    var form = this.$refs.form;
                    if (!form.checkValidity()) {
                        form.classList.add("was-validated");
                        return;
                    }

                    this.isSubmitting = true;
                    this.alertMessage = "";
                    this.alertErrors = [];
                    this.isComplete = false;

                    $.ajax({
                        url: "/api/dealers/",
                        method: "PUT",
                        contentType: "application/json",
                        data: JSON.stringify(this.dealer)
                    })
                        .done(resp => {
                            if (resp && resp.success) {
                                this.isComplete = true;
                                this.scrollToFormTop();
                                setTimeout(() => {
                                    this.close();
                                }, 900);
                            } else {
                                this.alertMessage = (resp && resp.message) || "Save failed.";
                                this.alertErrors = (resp && resp.data && resp.data.errors || []).map(e => e.description).filter(Boolean);
                                form.classList.add("was-validated");
                                this.scrollToFormTop();
                            }
                        })
                        .fail(() => {
                            this.alertMessage = "Save failed.";
                            form.classList.add("was-validated");
                            this.scrollToFormTop();
                        })
                        .always(() => {
                            this.isSubmitting = false;
                        });
                }
            },

            mounted: function () {
                $modal.off("show.bs.modal hidden.bs.modal");

                $modal.on("show.bs.modal", () => {
                    this.reset();
                    this.loadDealer()
                        .always(() => {
                            this.loadCountries();
                            this.loadReps();
                            this.isLoading = false;
                        });
                });

                $modal.on("shown.bs.modal", () => {
                    $modal.find("#close-icon").focus();
                });
            }
        });
    }

    function open(id, onClose) {
        $modal.data("id", id).modal("show");

        if (onClose) {
            $modal.one('hidden.bs.modal', onClose);
        }
    }

    return { init, open };
})(jQuery, Vue);

App.DealerDetail.init();